import React, {useState } from "react";
import NewPassword from "./NewPasswordForm";
import LoginHeader from "../Login/LoginHeader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetPasswordConfirm } from "../../store/authSlice";



const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [isNextPageTriggered, setNextPageTriggered] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { email } = useSelector((state) => state.auth);


  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const response = await dispatch(
        resetPasswordConfirm({ token, newPassword })
      ).unwrap();

      if (response.success) {
        setNextPageTriggered(true);
      } else {
        setError(response.message || "Something went wrong.");
      }
    } catch (err) {
      setError(err || "Failed to reset password.");
    }
  };
  
  return (
    <div>
      <LoginHeader loginPage={true} />
      {!isNextPageTriggered ? (
        <NewPassword 
        setNextPageTriggered={setNextPageTriggered}
         handleSubmit={handleSubmit}
         newPassword={newPassword}
         setNewPassword={setNewPassword}
         confirmPassword={confirmPassword}
         setConfirmPassword={setConfirmPassword}
         
         />
      ) : (
        <>
        <div className="flex items-center justify-center min-h-screen bg-white p-4">
          <div className="p-6 max-w-md w-full flex flex-col items-center justify-center">
            <div className="flex justify-center mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                role="img"
                aria-labelledby="confirmation-icon"
              >
                <title id="confirmation-icon">Confirmation Icon</title>
                <path
                  d="M18 2.25C22.1772 2.25 26.1832 3.90937 29.1369 6.86307C32.0906 9.81677 33.75 13.8228 33.75 18C33.75 22.1772 32.0906 26.1832 29.1369 29.1369C26.1832 32.0906 22.1772 33.75 18 33.75C13.8228 33.75 9.81677 32.0906 6.86307 29.1369C3.90937 26.1832 2.25 22.1772 2.25 18C2.25 13.8228 3.90937 9.81677 6.86307 6.86307C9.81677 3.90937 13.8228 2.25 18 2.25ZM16.038 21.1072L12.5392 17.6062C12.4138 17.4808 12.2649 17.3813 12.101 17.3134C11.9372 17.2456 11.7615 17.2106 11.5841 17.2106C11.4067 17.2106 11.2311 17.2456 11.0672 17.3134C10.9033 17.3813 10.7544 17.4808 10.629 17.6062C10.3757 17.8596 10.2334 18.2031 10.2334 18.5614C10.2334 18.9196 10.3757 19.2632 10.629 19.5165L15.084 23.9715C15.2091 24.0976 15.3579 24.1976 15.5218 24.2659C15.6857 24.3342 15.8615 24.3693 16.0391 24.3693C16.2167 24.3693 16.3925 24.3342 16.5565 24.2659C16.7204 24.1976 16.8692 24.0976 16.9943 23.9715L26.2192 14.7443C26.3464 14.6193 26.4475 14.4705 26.5168 14.3063C26.5861 14.1421 26.6222 13.9659 26.623 13.7877C26.6238 13.6094 26.5894 13.4328 26.5216 13.268C26.4538 13.1032 26.3541 12.9534 26.2282 12.8273C26.1022 12.7013 25.9526 12.6014 25.7878 12.5334C25.6231 12.4654 25.4465 12.4308 25.2683 12.4314C25.0901 12.432 24.9138 12.4679 24.7495 12.537C24.5853 12.6061 24.4363 12.707 24.3113 12.834L16.038 21.1072Z"
                  fill="black"
                />
              </svg>
            </div>
  
            {/* Title */}
            <h2
              className="text-center text-2xl font-semibold text-[#1D2739] mb-2"
              style={{ letterSpacing: "0.48px", lineHeight: "normal" }}
            >
              Password Updated
            </h2>
  
            {/* Subtitle */}
            <p className="text-center text-base text-gray mb-10">
              {`Your password for ${email} has been updated. Return to the
              login page to sign in.`}
            </p>
  
            <button
              type="button"
              className={`flex justify-center cursor-pointer items-center self-center w-full sm:w-[432px] h-14 p-5 mt-14
              rounded-[13px] text-center text-base font-medium bg-[#eaf524] text-black`}
              aria-label="Continue to profile"
              onClick={() => navigate("/login")}
            >
              Back to login
            </button>
          </div>
        </div>
      </>
      )}
    </div>
  );
};

export default ResetPassword;